export default {
  general: {
    employee: "Employee",
    unknown_user: "Unknown User",
    no_employees_found: "No employees found",
  },
  overview: {
    title: "Employee Overview",
    archive_title: "Employees who have left",
    // The employees' archive is named for what it means for a person.
    archive_show: "Show who has left",
    archive_hint: "They cannot sign in and appear in no list. Open a person to reactivate them.",
    subtitle: "List of all employees.",
    actions: {
      create_new: "Create New Employee",
    },
    search: {
      placeholder: "eg. E-Mail, lastname, firstname, etc.",
    },
    table: {
      headers: {
        id: "ID",
        name: "Employee",
        lastname: "Last name",
        firstname: "First name",
        email: "E-Mail",
        phone: "Phone",
        createdAt: "Created at",
      },
      no_email_set: "-No email-",
      no_position_set: "-No position-",
      login: {
        none: "No login",
        disabled: "Login disabled",
        active: "Has login",
      },
    },
  },
  create: {
    title: "Create Employee",
    subtitle: "Create a new employee.",
    duplicate_dialog: {
      title: "Employee already exists",
      text: "An employee with the name <strong>{name}</strong> already exists. Is this a different person?",
      existing_label: "Existing employees with this name:",
      confirm: "Yes, create anyway",
      cancel: "Cancel",
    },
    dialog_title: "New User",
    dialog_subtitle: "Select the type of user to create",
    auth_user: {
      title: "Login User",
      text: "Can log in and access the web platform.",
    },
    data_user: {
      title: "Management User",
      text: "<strong>Cannot</strong> log in. Used for internal management only.",
    },
    seat_hint: "Only login users take up a paid seat. You can create as many management users as you like.",
  },
  detail: {
    title: "Employee Details",
    user_type_tooltip: {
      web: "Can sign in",
      data: "Internal management only",
    },
    tabs: {
      general: "General",
      company: "Company relevant",
      system: "System specific",
      files: "File storage",
      extended: "Extended",
      activity: "Activity",
    },
    actions: {
      actions: "Actions",
      times: "Review times",
      planning: "Show in personnel planning",
      add_custom_field: "Add Custom Field",
      upload_avatar: "Upload Image",
      change_avatar: "Change Image",
      remove_avatar: "Remove",
      initial_avatar: "To add a Profile picture, you firstly need to create the User.",
      update: "Save",
      // Left the company = archived (docs/archiving.md): no sign-in, no seat, out of every picker.
      archive: {
        // "Remove": somebody who already recorded something is marked as having left, anybody else deleted.
        text: "The person can no longer sign in, holds no seat and appears in no list, picker or planning, including the time review: approve their last hours first. If they already recorded something, they are marked as having left: their reports, time and absences stay, and you can reactivate them at any time. Otherwise they are deleted.",
        restore: "Reactivate",
        hint: "Has left: cannot sign in and holds no seat.",
      },
      reset_password: {
        reset_password_via_mail: "Reset Password via Mail",
        reset_password_manually: "Reset Password manually",
        modal: {
          title: "Reset Password",
          text_mail: "Are you sure you want to send an E-Mail where the user can update his current password?",
          text_manual: "Are you sure you want to overwrite the current user password?",
          password_input: "New Password",
          password_input_verify: "Enter Password again",
          password_verify_invalid: "Passwords do not match",
          agree: "Agree",
          disagree: "Cancel",
        },
      },
      convert: {
        convert_to_login: "Convert to Login User",
        modal: {
          title: "Convert to Login User",
          subtitle: "The employee will receive their login credentials via email and can then sign in to the web platform.",
          seat_hint: "The employee will then take up a paid seat.",
        },
      },
    },
    form: {
      personnel_number: "Personnel Number",
      personnel_type: "Personnel Type",
      personnel_kind: "Personnel Kind",
      entry_date: "Entry Date",
      exit_date: "Exit Date",
      wage_type: "Wage type",
      wage_value: "Wage",
      HOURLY_WAGE: "Hourly Wage", // Name must be equal to property name
      MONTHLY_WAGE: "Monthly Wage", // Name must be equal to property name
      YEARLY_WAGE: "Yearly Wage", // Name must be equal to property name
      holiday_days: "Total Holiday Days",
      empowerment: "Empowerment",
      employer_contribution: "Employer's contribution",
      employer_contribution_hint:
        "Surcharge on labour cost (social security). Leave empty to use the default from the settings: {percent} %.",
      social_insurance_number: "Social Insurance Number",
      insurance: "Insurance",
      birthday_date: "Birthdate",
      first_name: "Firstname",
      last_name: "Lastname",
      telephone_number: "Telephone Number",
      profile_picture: "Profile Picture",
      personal_data: "Personal Data",
      address: "Address",
      state: "State",
      street: "Street",
      location: "Place",
      country: "Country",
      main_language: "Main Language",
      main_language_hint:
        "The Lewara app asks for its language when first opened. Where another one is picked there, it offers this one once after signing in. Empty: the phone's language.",
      postcode: "Postcode",
      house_number: "House Number",
      email: "E-Mail",
      position: "Employee Position",
      custom_fields: {
        text: "User custom fields",
        title: "Create new custom field",
        subtitle: "As soon as you create a new field, it is created for all employees.",
        submit: "Create",
        cancel: "Cancel",
        label_field: "Field name",
        label_placeholder: "brief description",
      },
      roles: {
        title: "Role-Assignment",
        role: "Role",
        active: "Assigned Roles",
        inactive: "Available Roles",
        empty_active: "No roles assigned yet",
        empty_inactive: "All roles assigned",
      },
    },
  },
  position: {
    no_results: 'No results matching "<strong>{value}</strong>"',
    overview: {
      title: "All User Positions",
      subtitle: "List of all User Positions.",
      empty_items: "No positions available",
      add_item: "Add new position",
    },
    configure: "Configure",
  },
}
